import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiClientService } from '@services/api-client';
import { DropdownItem } from '@shared/components/dropdown/dropdown.component';
import { ReplaySubject, share, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CachedValuesService {
    private readonly apiClientService = inject(ApiClientService);
    private readonly translateService = inject(TranslateService);
    private invalidateCacheSubject = new Subject<void>();
    private invalidateCache$ = this.invalidateCacheSubject.asObservable();

    public users$ = this.apiClientService.getUsers$().pipe(
        share({
            connector: () => new ReplaySubject(1),
            resetOnComplete: () => this.invalidateCache$
        })
    );

    public devices$ = this.apiClientService.getDevices$().pipe(
        share({
            connector: () => new ReplaySubject(1),
            resetOnComplete: () => this.invalidateCache$
        })
    );

    public locations$ = this.apiClientService.getLocations$().pipe(
        share({
            connector: () => new ReplaySubject(1),
            resetOnComplete: () => this.invalidateCache$
        })
    );

    public regions$ = this.apiClientService.getRegions$().pipe(
        share({
            connector: () => new ReplaySubject(1),
            resetOnComplete: () => this.invalidateCache$
        })
    );

    public tenants$ = this.apiClientService.getTenants$().pipe(
        share({
            connector: () => new ReplaySubject(1),
            resetOnComplete: () => this.invalidateCache$
        })
    );

    public firmwareVersions$ = this.apiClientService.getFirmwareVersions$().pipe(
        share({
            connector: () => new ReplaySubject(1),
            resetOnComplete: () => this.invalidateCache$
        })
    );

    public generateNumericDropdownItems(to: number, from: number = 0): DropdownItem<number>[] {
        const items: DropdownItem<number>[] = [];
        for (let i = from; i <= to; i++) {
            items.push({
                value: i,
                label: `${i}`
            });
        }
        return items;
    }

    public invalidateCache() {
        this.invalidateCacheSubject.next();
    }
}
